module.exports = __webpack_public_path__ + "img/Earphone_100h.9f1512b1.png";